import React from "react";

class Root extends React.Component {
  render() {
    return (
      <div className="card">
        For å benytte denne tjenesten trenger du en unik lenke knyttet til deg
        som bruker/selskap.
      </div>
    );
  }
}

export default Root;



// WEBPACK FOOTER //
// ./src/components/Root.js